// Choose API base:
// 1) Respect REACT_APP_API_BASE_URL when provided.
// 2) Otherwise derive from current origin, assuming XAMPP layout.
const detectApiBaseUrl = () => {
  const normalize = (val) => (val || "").trim().replace(/\/+$/, "");
  const env = normalize(process.env.REACT_APP_API_BASE_URL);
  const hasWindow = typeof window !== "undefined" && !!window.location;
  const origin = hasWindow ? window.location.origin : "";
  const path = hasWindow ? window.location.pathname || "/" : "/";

  if (env) {
    // If the app is served from /primecloudsystems_com but env forgot that segment,
    // add it so requests hit the PHP folder under the same parent.
    if (
      hasWindow &&
      path.includes("/primecloudsystems_com/") &&
      env.startsWith(origin) &&
      !env.includes("/primecloudsystems_com/")
    ) {
      try {
        const u = new URL(env);
        return `${u.origin}/primecloudsystems_com${u.pathname}${u.search}`.replace(
          /\/+$/,
          "",
        );
      } catch {
        // fall through and return env
      }
    }
    return env;
  }

  if (!hasWindow) return "";

  // Default guesses for local XAMPP
  return path.includes("/primecloudsystems_com/")
    ? `${origin}/primecloudsystems_com/primecloudsystems_api`
    : `${origin}/primecloudsystems_api`;
};

const API_BASE_URL = detectApiBaseUrl();

// Log API base URL for debugging (remove in production if needed)
if (typeof window !== "undefined" && process.env.NODE_ENV !== "production") {
  console.log("API Base URL:", API_BASE_URL);
}

const API = {
  base: API_BASE_URL,

  // Login method - sends JSON data
  login: async (email, password) => {
    const url = `${API.base}/login.php`;

    const encode = (value) => {
      try {
        if (typeof window !== "undefined" && window.btoa) {
          return window.btoa(unescape(encodeURIComponent(value)));
        }
        return btoa(value);
      } catch {
        return value;
      }
    };

    try {
      const payload = new URLSearchParams();
      payload.append("email", encode(email.trim()));
      payload.append("password", encode(password));

      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: payload,
      });

      if (!res.ok && res.status !== 401 && res.status !== 400) {
        const errorText = await res.text();
        throw new Error(`HTTP error! status: ${res.status} - ${errorText}`);
      }

      const data = await res.json();
      return { data, status: res.status };
    } catch (err) {
      if (err.message.includes("fetch")) {
        throw new Error(
          `Cannot connect to ${url}. Please check your API configuration.`,
        );
      }
      throw err;
    }
  },

  // General POST method for authenticated requests
  post: async (url, data) => {
    const token = localStorage.getItem("authToken") || "";
    try {
      const res = await fetch(API.base + url, {
        method: "POST",
        headers: {
          Authorization: token,
          ...(data instanceof FormData
            ? {}
            : { "Content-Type": "application/x-www-form-urlencoded" }),
        },
        body: data instanceof FormData ? data : new URLSearchParams(data),
      });

      if (!res.ok) {
        const errorText = await res.text();
        console.error(`API Error (${res.status}):`, errorText);
        throw new Error(`HTTP ${res.status}: ${errorText}`);
      }

      const jsonData = await res.json();
      return { data: jsonData, status: res.status };
    } catch (err) {
      console.error(`API Request Failed (${API.base + url}):`, err);
      throw err;
    }
  },
};

export default API;
